export const getCabernetSauvignonFranceData = () => ({
  name: "Cabernet Sauvignon",
  country: "France",
  description: "Le Cabernet Sauvignon est principalement cultivé dans le Bordelais, particulièrement sur la rive gauche de la Garonne.",
  regions: [
    { name: "Médoc", area: "15,000 ha", percentage: "45%", description: "Cépage principal des grands crus" },
    { name: "Graves", area: "8,000 ha", percentage: "24%", description: "Vins d'assemblage" },
    { name: "Saint-Émilion", area: "5,000 ha", percentage: "15%", description: "Assemblage avec Merlot" },
    { name: "Pomerol", area: "3,000 ha", percentage: "9%", description: "Usage limité" },
    { name: "Autres", area: "2,000 ha", percentage: "7%", description: "Dispersé dans le Bordelais" }
  ],
  mapAreas: [
    { region: "Médoc", x: 25, y: 70, color: "#4B164C", size: 8 },
    { region: "Graves", x: 30, y: 75, color: "#6d2c7a", size: 6 },
    { region: "Saint-Émilion", x: 35, y: 72, color: "#8a4a8a", size: 4 },
    { region: "Pomerol", x: 33, y: 73, color: "#a768a6", size: 3 }
  ],
  subregions: {
    bordeaux: {
      name: "Bordeaux",
      description: "Le Cabernet Sauvignon de Bordeaux est le cépage roi des vins rouges de la rive gauche, particulièrement dans le Médoc et les Graves.",
      characteristics: {
        aromas: "Cassis, cèdre, tabac, cuir, notes minérales",
        body: "Corps moyen à plein",
        tannins: "Tannins fermes et structurés",
        aging: "Excellent potentiel de vieillissement (10-30 ans)"
      },
      terroir: {
        climate: "Climat océanique tempéré",
        soil: "Graves et argiles du Médoc",
        viticulture: "Rendements limités, vendanges manuelles"
      },
      differentiators: [
        "Élégance et finesse uniques grâce aux sols de graves",
        "Complexité aromatique développée par le vieillissement",
        "Structure tannique équilibrée caractéristique du terroir",
        "Notes de cèdre et de tabac distinctives"
      ],
      foodPairing: "Viandes rouges, gibier, fromages affinés, chocolat noir"
    }
  }
}); 